import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { auditLogPaths } from './paths';

const { AuditLogView } = lazyImport(() => import('../views/auditLog'), 'AuditLogView');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const auditLogRoutes: RouteObject[] = [
  {
    path: auditLogPaths.absolute,
    element: <Layout />,
    children: [{ path: '', element: <AuditLogView /> }],
  },
];
